import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ACTION_MENU_HEADER_CLASS_NAME = 'ActionMenuHeader';
export const ACTION_MENU_HEADER_CLASS_SLOTS: Array<
	keyof ActionMenuHeaderClasses
> = ['root', 'title'] as const;

export type ActionMenuHeaderClassSlot =
	(typeof ACTION_MENU_HEADER_CLASS_SLOTS)[number];

export interface ActionMenuHeaderClasses {
	root: string;
	title: string;
}

export type ActionMenuHeaderClassKey = keyof ActionMenuHeaderClasses;

export const getActionMenuHeaderUtilityClass = (slot: string) =>
	generateUtilityClass(
		ACTION_MENU_HEADER_CLASS_NAME,
		slot as ActionMenuHeaderClassSlot,
	);

export const actionMenuHeaderClasses: ActionMenuHeaderClasses =
	generateUtilityClasses(ACTION_MENU_HEADER_CLASS_NAME, ['root', 'title']);

export default actionMenuHeaderClasses;
